export default {"src":"/_next/static/media/errorIcon.2e95795e.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};